<template>
  <div>
    <div :class="divWidthChange" class="conteudoWidth">
      <div class="row mt-3">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actions"
            :items="lstTipoDeficiencia"
            responsive
            :porPage="itemPorPage"
            :optionsButton="optionButtonsSolicitacao"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePage"
          />
        </div>
      </div>
    </div>
    <fccModal
      centered
      idModal="addSolicitacoesEspecificas"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      @close="criar = {}"
      travaBack
      size="lg"
    >
      <fcc-solicitacao-especifica-t-deficiencia
        :tipodeficiencia="criar"
        v-if="criar.tpdeficienciapublicacao != null"
      />
    </fccModal>
  </div>
</template>
  <script>
import axios from 'axios'
import store from '@/store'
import FccSolicitacaoEspecificaTDeficiencia from './FccSolicitacaoEspecificaTDeficiencia.vue'
export default {
  components: { FccSolicitacaoEspecificaTDeficiencia },
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Tipo Deficiência',
      itemPorPage: '100',
      lstTipoDeficiencia: [],
      lstSolicitacaoEspecifica: [],
      lstServidores: [],
      mostraSenha: false,
      titleModal: '',
      criar: {},
      optionButtonsSolicitacao: [
        {
          funcaoButton: 'restauraSolicitacao',
          text: 'Restaurar Solicitações',
          tooltip: 'Restaurar Solicitações',
          variant: 'primary',
          icon: 'history',
          objpermCodigo: store.state.permissaoMenu.alterar
        }
      ],
      fields: [
        { key: 'tpdeficiencia', label: 'ID', sortable: true, active: true },
        {
          key: 'tpdeficienciapublicacao',
          label: 'ID Deficiência Publicação',
          sortable: true,
          active: true
        },

        { key: 'deficiencia', label: 'Tipo Deficiência', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'listSolicitacaoEspecial',
          icon: 'list',
          tooltip: 'Solicitação Especial',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteTipoDeficienciaPublicacao',
          icon: 'trash',
          tooltip: 'Deletar',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  props: {
    idPublicacao: {
      type: Number,
      required: true
    },
    lstSolicitacoes: {
      type: Object,
      required: true
    }
  },
  methods: {
    listarMetaTipoDeficiencia() {
      this.listaMetaDadoTipoDeficienciaGenerica(
        this.lstSolicitacoes.idsolicitacaocondicaopublicacao
      )
        .then((response) => {
          this.lstTipoDeficiencia = response
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    restauraSolicitacao() {
      this.callConfirm('Deseja restaurar os dados para o padrão', '').then((result) => {
        this.carregaTexto(this.codeMensagem('C01'))
        if (result.value) {
          this.$emit('salvarMetadados', this.idPublicacao, true)
        }
      })
    },
    listSolicitacaoEspecial(_, item) {
      this.titleModal = 'Solicitações Específicas - ' + item.deficiencia
      this.criar = item
      this.$root.$emit('bv::show::modal', 'addSolicitacoesEspecificas')
    },
    sucessoSituacao(texto) {
      this.listarMetaTipoDeficiencia()
      this.callToast(texto)
      this.$root.$emit('bv::hide::modal', 'addSolicitacoesEspecificas')
    },
    deleteTipoDeficienciaPublicacao(_, item) {
      this.callConfirm(this.mensagemExcluir, item.deficiencia).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlLaudoMedico +
                'MetadadoTipoDeficienciaPublicacao/Excluir/' +
                item.tpdeficienciapublicacao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.sucessoSituacao(this.mensagensUpdate.excluido)
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto)
        }
      })
    }
  },
  mounted() {
    this.listarMetaTipoDeficiencia()
    //listaMetaDadoTipoDeficiencia
  }
}
</script>
          